/**
 * Provision the core purchase-- guide account, instant course purchase, etc.
 */

import { CORE_INSTANT_COURSES_PRODUCT_ID } from 'shared/ids';
import { CheckoutPage, ProvisioningForm } from '@course/components/checkout';
import { LoadedProps, RouteLoadProps, defRoute } from '@components/router';
import { rpx } from 'client/lib/rpx-client';
import { ErrorPage } from '@components/error-page';
import { CoreBanner } from './core-banner';
import { HyrosTracker } from './hyros-tracker';

export const route = defRoute({
  load,
  Page,
});

async function load(route: RouteLoadProps) {
  const purchases = await rpx.payments.getPurchases({
    priceId: route.params.priceId,
    status: ['provisioning', 'active', 'complete'],
    limit: 1,
  });

  return { purchase: purchases.data[0] };
}

type Props = LoadedProps<typeof load>;

function Page(props: Props) {
  const { purchase } = props.state;
  const isInstantCourseCheckout = purchase?.productId === CORE_INSTANT_COURSES_PRODUCT_ID;

  if (!purchase) {
    return <ErrorPage title="404 | Not Found"></ErrorPage>;
  }

  const provision = async () => {
    const priceId = purchase.priceId;
    let url = '/welcome';
    if (isInstantCourseCheckout) {
      await rpx.myCorePayments.provisionInstantCourseCredits({ priceId });
      url = '/instant-courses';
    } else {
      await rpx.myCorePayments.provisionGuideAccount({ priceId });
    }
    location.assign(url);
    return url;
  };

  return (
    <CheckoutPage bannerContent={<CoreBanner />}>
      <HyrosTracker />
      <ProvisioningForm provision={provision} purchase={purchase} />
    </CheckoutPage>
  );
}
